'use strict';

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReviewService {
  private apiUrl = 'reviews';

  constructor(private http: HttpClient) {}

  /**
   * Submit a new review for a session.
   */
  createReview(data: { 
    booking_id: string; 
    rating: number; 
    message: string; 
  }): Observable<any> {
    return this.http.post(this.apiUrl, data);
  }

  /**
   * Update an existing review.
   */
  updateReview(reviewId: string, data: {
    rating: number;
    message: string;
  }): Observable<any> {
    return this.http.put(`${this.apiUrl}/${reviewId}`, data);
  }

  /**
   * Submit a tutor response/comment to a review.
   */
  submitComment(reviewId: string, message: string): Observable<any> {
    return this.http.post(`${this.apiUrl}/${reviewId}/comment`, { message });
  }

  /**
   * Update an existing tutor response/comment.
   */
  updateComment(commentId: string, message: string): Observable<any> {
    return this.http.put(`${this.apiUrl}/comment/${commentId}`, { message });
  }

  /**
   * Get reviews for the logged-in tutor.
   */
  getMyReviews(params: { page?: number; limit?: number } = {}): Observable<any> {
    return this.http.get(`${this.apiUrl}/my-reviews`, { params });
  }

  /**
   * Get overall review stats for the logged-in tutor.
   */
  getReviewStats(): Observable<any> {
    return this.http.get(`${this.apiUrl}/stats`);
  }

  /**
   * Get public reviews for a specific tutor.
   */
  getTutorReviews(tutorId: string, params: { page?: number; limit?: number } = {}): Observable<any> {
    return this.http.get(`${this.apiUrl}/tutor/${tutorId}`, { params });
  }
}
